module.exports = __webpack_public_path__ + "img/garden_dsj_2.40f17d12.png";